<template>
  <div class="layout-page">
    <div class="layout-header">
      <Header />
    </div>
    <div class="layout-container">
      <div class="layout-menu">
        <Menu />
      </div>
      <div class="layout-content">
        <div class="layout-content-header">
          <NavHeader />
        </div>
        <div class="layout-content-main">
          <transition  name="fade-transform" mode="out-in">
            <!-- <keep-alive > -->
              <router-view :key="$route.fullPath"></router-view>
            <!-- </keep-alive> -->
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "./header";
import Menu from "./menu";
import NavHeader from "./navHeader";

export default {
  name: "layout",
  components: { Header, Menu, NavHeader }
};
</script>
<style>


.layout-page {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.layout-page .layout-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 60px;
  color: #fff;
  background-color: #409EFF;
}
.layout-page .layout-container {
  display: flex;
  flex-direction: row;
  flex: 1;
  overflow: hidden;
  height: 100%;
}
.layout-page .layout-container .layout-content {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  overflow: hidden;
}
.layout-page .layout-container .layout-content .layout-content-main {
  display: flex;
  height: 100%;
  flex: 1;
  overflow: hidden;
}
</style>
